module.exports = __webpack_public_path__ + "assets/img/en-763b01bb.png";